import { createSlice } from '@reduxjs/toolkit';
import { MessageAlertType } from "models/commonModel";

interface StateProps {
    triggerFastLottery: boolean;
    alertMsg: {
        message: string | null;
        type: MessageAlertType;
    };
    cdnUrl: string;
}
export const configSlice = createSlice({
    name: 'config',
    initialState: {
        triggerFastLottery: false,
        alertMsg: {
            message: null,
            type: 'error',
        },
    } as StateProps,
    reducers: {
        toggleFastLotteryHome(state, action) {
            state.triggerFastLottery = action.payload;
        },
        toggleMessage(state, action) {
            state.alertMsg = action.payload;
        },
        cacheUrlCDN(state, action) {
            state.cdnUrl = action.payload;
        },
    },
});

const { actions, reducer } = configSlice;

export const { toggleFastLotteryHome, toggleMessage, cacheUrlCDN } = actions;
export default reducer;
